angular.module('impactx.rfx').controller('RFXTextCustomizationCtrl', [
    '$scope',
    'dataGen',
    'TranslationService',
    'ToastService',
    '$mdDialog',
    'RFXBuyerService',
    '$config',
    RFXTextCustomizationCtrl]);

function RFXTextCustomizationCtrl($scope, dataGen, TranslationService, ToastService, $mdDialog, RFXBuyerService, $config) {
    var self = this;

    $scope.abortLabel = TranslationService.get("abort");
    $scope.saveLabel = TranslationService.get("save");
    $scope.requiredLabel = TranslationService.get("required");
    $scope.currentSupplierIndex = 0;
    $scope.tinymceOptions = $config.tinymceOptions;

    // nextStatus is one of RFXBuyerService.STATUS
    function getData() {
        var paramObject = {rfqhId: self.rfqhId, nextStatus: self.nextStatus};
        if (self.selectedRfqsIds) {
            paramObject.selectedRfqsIds = self.selectedRfqsIds;
        }
        dataGen.postAsForm($scope, paramObject, "/rfx/buyer/textcustomization").then(angular.noop, function () {
            $mdDialog.cancel();
        });
    }

    function saveData() {
        return dataGen.postAsForm({}, {data: $scope.data}, "/rfx/buyer/textcustomization/save");
    }

    self.saveAndSend = function () {
        saveData().then(function () {
            $mdDialog.hide({send: true});
        });
    };

    self.save = function () {
        saveData().then(function () {
            $mdDialog.hide({send: false});
        });
    }

    self.next = function () {
        $scope.currentSupplierIndex++;
    }

    self.previous = function () {
        $scope.currentSupplierIndex--;
    }

    self.cancel = function () {
        $mdDialog.cancel();
    };

    getData();
}